import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState, type PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { GlobalLoader } from '@/components/GlobalLoader';
import { useMe } from '@/providers/User';

import { ROUTES } from './routes';

const AuthenticatedRoute = ({ children }: PropsWithChildren) => {
  const user = useMe();
  const ldClient = useLDClient();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (ldClient && user) {
      ldClient
        .waitForInitialization(5)
        .then(() => {
          setIsInitialized(true);
        })
        .catch(() => {
          setIsInitialized(true);
        });
    }
  }, [ldClient, user]);

  if (!user) {
    // set a `redirect` search param to the current path
    const { pathname, search } = window.location;
    const currentPath = encodeURIComponent(`${pathname}${search}`);
    const redirect = `${ROUTES.signIn.path}?redirect=${currentPath}`;
    return <Navigate to={redirect} replace />;
  }

  if (!isInitialized) {
    return <GlobalLoader />;
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
